module.exports = __webpack_public_path__ + "img/1-2.2俞敏洪（新东方）.971e80ed.jpg";